import {
  AfterViewInit,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { MENU_BUTTON_CODE, MENU_BUTTON_FORM, TabNames, collection_composed_images, menu_button_map } from "src/app/core/services/constants";
import { IndexDBService } from "src/app/core/services/indexDB.service";
import { Tab } from "src/app/core/services/interface";
import { MiddlwareService } from "src/app/core/services/middleware.service";
import { WebsocketService } from "src/app/core/services/websocket.service";
import { BuilderService } from "src/app/sharedservices/builder.service";
@Component({
  selector: "app-offcanvas-button-drag",
  templateUrl: "./offcanvas-button-drag.component.html",
  styleUrls: ["./offcanvas-button-drag.component.scss"],
})
export class OffcanvasButtonDragComponent
  implements OnInit, AfterViewInit, OnDestroy {
  constructor(
    private ws: WebsocketService,
    private mdw: MiddlwareService,
    public indexDBService: IndexDBService,
    private builderService: BuilderService
  ) { }
  ngAfterViewInit(): void { }
  @Input() data: Tab;
  @Input() mode: string;
  @Input() offcanvas_data: any[] = [];

  offCanvasSubscription: any;
  // default values
  colors;
  app_info;
  bg_color;
  text_color;
  burger_icon_color;
  app_name_color;
  other_text_color;
  channel_name: string;
  off_canvas_key = "home";
  selectedElement: any;
  customizationSubscription: any;
  signupFormMultipleScreen= false

  ngOnInit() {

  this.customizationSubscription = this.mdw.customizationContainer$.subscribe(async (data) => {
      if (data) {
        if (data.signupFormMultipleScreen){
           this.signupFormMultipleScreen = true;
        }

      }
    });

    this.offCanvasSubscription = this.mdw.offCanvasContainer$.subscribe(
      (data) => {
        if (data && data.target == 'drag') {
          switch (data.off_canvas_key) {
            case "menu":
              this.offcanvas_data = [
                {
                  tab: "Basic",
                  data: [
                    {
                      cat: "Components",
                      show: true,
                      name: "Headline",
                      icon: "title",
                      icon_color: "#349fff",
                      item: this.singleButton("bar_01", "bar", "1004"),
                    },
                     {
                      cat: "Filler",
                      show: true,
                      name: "Filler",
                      icon: "square",
                      icon_color: "#fffff",
                      item: this.singleButton("filler_01", "filler", "1004"),
                    },
                    {
                      cat: "Components",
                      show: false,
                      list: [
                        {
                          id: "Cards",
                          name: "Cards",
                          icon: "space_dashboard",
                          icon_color: "#52ef7a",
                          options: [
                            this.singleButton("card_06", "card", "0603",),
                            this.singleButton("card_03", "card", "0303",),
                            this.singleButton("card_05", "card", "0503",),
                            this.singleButton("card_04", "card", "0403",),
                            this.singleButton("card_07", "card", "0703",),
                            this.singleButton("card_08", "card", "0803",),

                              //remove start
                            // this.singleRow([{ code: "card_0901", form: "card", style: "0903" },  { code: "card_0902", form: "card", style: "0903"  }],"Row", "", collection_composed_images ["card-0901-0902"].image, 60),
                            // this.singleRow([{ code: "card_1001", form: "card", style: "1003" },  { code: "card_1002", form: "card", style: "1003"  }],"Row", "", collection_composed_images ["card-1001-1002"].image, 60),
                            this.singleRow([{ code: "card_1101", form: "card", style: "1103" },  { code: "card_1102", form: "card", style: "1103"  }],"Row", "", collection_composed_images ["card-1101-1102"].image, 60),
                            // this.singleRow([{ code: "card_1201", form: "card", style: "1204" },  { code: "card_1202", form: "card", style: "1204"  }, { code: "card_1203", form: "card", style: "1204"  }, { code: "card_1204", form: "card", style: "1204"  }],"Row", "", collection_composed_images ["card-1201-1204"].image, 60),
                            //remove End

                            this.singleRow([{ code: "card_1301", form: "card", style: "1304" },  { code: "card_1302", form: "card", style: "1304"  }, { code: "card_1303", form: "card", style: "1304"  }],"Row", "", collection_composed_images ["card-1301-1303"].image, 60),
                            this.singleRow([{ code: "card_1401", form: "card", style: "1404" },  { code: "card_1402", form: "card", style: "1404"  }, { code: "card_1403", form: "card", style: "1404"  }],"Row", "", collection_composed_images ["card-1401-1403"].image, 60),

                            /// remove Start
                            // this.singleButton("card_18", "card", "1804",),
                            // this.singleButton("card_19", "card", "1904",),
                             this.singleButton("card_21", "card", "2103",),
                             this.singleButton("card_2203", "card", "2203",),
                             this.singleRow([{ code: "card_2303", form: "card", style: "2303" },  { code: "card_2303", form: "card", style: "2303"  },],"Row", "", collection_composed_images ["card-2303-2303"].image, 60),
                             this.singleRow([{ code: "card_2101", form: "card", style: "2103" },  { code: "card_2102", form: "card", style: "2103"  },],"Row", "", collection_composed_images ["card-2101-2102"].image, 60),

                            // remove End
                          ],

                        },
                           {
                          id: "Avatar Cards",
                          name: "Avatars",
                          icon: "account_box",
                          icon_color: "#b27df3",
                          options: [
                            // this.singleButton("card_12", "card", "1204",),
                            this.singleButton("card_15", "card", "1504",),
                            this.singleButton("card_16", "card", "1604",),
                            // this.singleButton("card_17", "card", "1704",),
                            this.singleButton("card_20", "card", "2004",),
                          ],

                        },

                        {
                          id: "Carousel",
                          name: "Carousel",
                          icon: "view_carousel",
                          icon_color: "#ee695e",
                          options: [
                            this.singleButton("carousel_02", "carousel", "0200",),
                            this.singleButton("carousel_03", "carousel", "0300",),
                            this.singleButton("carousel_04", "carousel", "0400",),
                            this.singleButton("carousel_01", "carousel", "0100",),
                          ],
                        },
                        {
                          id: "Text Fields",
                          name: "Text Fields",
                          icon: "text_fields",
                          icon_color: "#ffd96a",
                          options: [
                            this.singleButton("inout_01", "inout", "01",),
                            this.singleButton("inout_03", "inout", "03",),
                            this.singleButton("inout_02", "inout", "02",),

                            this.singleButton("inout_11", "inout", "11",),
                            this.singleButton("inout_12", "inout", "12",),
                            this.singleButton("inout_13", "inout", "13",),

                            this.singleButton("inout_21", "inout", "21",),
                            this.singleButton("inout_32", "inout", "32",),
                            this.singleButton("inout_33", "inout", "33",),
                          ],
                        },

                        {id: "Text Area",
                          name: "Text Area",
                          icon: "text_format",
                          icon_color: "#ee695e",
                          options: [
                          this.singleButton("text_01", "text", "1004",),
                          ],
                        },
                        {
                          id: "Radio Button",
                          name: "Radio Button",
                          icon: "radio_button_checked",
                          icon_color: "#5671ff",
                          options: [
                            this.singleButton("singlechoice_1000", "singlechoice", "1000",),
                            this.singleButton("singlechoice_2000", "singlechoice", "2000",),
                            this.singleButton("singlechoice_3000", "singlechoice", "3000",),
                          ],
                        },
                        {
                          id: "Checkbox",
                          name: "Checkbox",
                          icon: "check_box",
                          icon_color: "#e78775",
                          options: [
                            this.singleButton("multiplechoice_1000", "multiplechoice", "1000",),
                            this.singleButton("multiplechoice_2000", "multiplechoice", "2000",),
                            this.singleButton("multiplechoice_3000", "multiplechoice", "3000",),
                          ],
                        },
                       {
                          id: "Toggles",
                          name: "Toggles",
                          icon: "toggle_off",
                          icon_color: "#c582d5",
                          options: [
                            this.singleButton("toggle_1000", "toggle", "1000",),
                            this.singleButton("toggle_2000", "toggle", "2000",),
                            this.singleButton("toggle_3000", "toggle", "3000",),
                          ],
                        },
                        {
                          id: "Dropdown",
                          name: "Dropdown",
                          icon: "expand_circle_down",
                          icon_color: "#1abb9c",
                          options: [
                            this.singleButton("dropdown_01", "dropdown", "01",),
                            this.singleButton("dropdown_03", "dropdown", "03",),
                            this.singleButton("dropdown_02", "dropdown", "02",),
                          ],
                        },
                        {
                          id: "Button",
                          name: "Buttons",
                          //icon: "indeterminate_check_box",
                          icon:"edit_attributes",
                          icon_color: "#22d1ee",

                          options: [
                            this.singleButton("button_04", "button", "04",),
                            this.singleButton("button_01", "button", "01",),
                            this.singleButton("button_03", "button", "03",),
                            this.singleButton("button_02", "button", "02",),
                            this.singleButton("button_05", "button", "05",),
                            this.singleButton("singlechoice_segmented_menu_1000", "singlechoice_segmented_menu", "1000",),
                            this.singleButton("multichoice_segmented_menu_1000", "multichoice_segmented_menu", "1000",),
                         ],
                        },
                        {
                          id: "Chips",
                          name: "Chips",
                          icon: "check_box",
                          icon_color: "#D0BCFF",
                          options: [
                            this.singleButton("assist_chipset_menu_0102", "assist_chipset", "0102",), //assist outline
                            this.singleButton("single_chipset_menu_0102", "single_chipset", "0102",),  //single Filter outline
                            this.singleButton("multi_chipset_menu_0102", "multi_chipset", "0102",),  //multi Filter outline
                            this.singleButton("single_chipset_menu_0202", "single_chipset", "0202",),  //single Suggestion outline
                            this.singleButton("multi_chipset_menu_0202", "multi_chipset", "0202",), //multi Suggestion outline
                            //this.singleButton("dropdown_chip_menu_02", "dropdown_chip", "0200",),
                          ],
                        },

                       {
                          id: "Output Cells",
                          name: "Output Cells",
                          icon: "output",
                          icon_color: "#f0a878ff",
                          options: [
                            this.singleButton("out_01", "out", "01",),
                            this.singleButton("out_02", "out", "02",),
                            this.singleButton("out_03", "out", "03",),

                          ],
                        },
                        {
                          id: "Search",
                          name: "Search View",
                          icon: "search",
                          icon_color: "#ee695e",
                          options: [
                            this.singleButton("searchview_01", "searchview", "01",)
                          ],
                        },
                         {
                          id: "map",
                          name: "Map Preview",
                          icon: "map",
                          icon_color: "#7044c2ff",
                          options: [
                            this.singleButton("map_01", "map", "0103",),
                          ],
                        },

                        {
                          id: "slider",
                          name: "Sliders",
                          icon: "display_settings",
                          icon_color: "#FDD835",
                          options: [
                            this.singleButton("single_slider_01", "single_slider", "01",),
                            this.singleButton("single_slider_02", "single_slider", "02",),
                            this.singleButton("single_slider_03", "single_slider", "03",),
                            this.singleButton("range_slider_01", "range_slider", "01",),
                          ],
                        },
                        {
                          id: "date",
                          name: "Date Pickers",
                          icon: "today",
                          icon_color: "#FF9800",
                          options: [
                            this.singleButton("date_picker_01", "date_picker", "01",),
                            this.singleButton("date_picker_03", "date_picker", "02",),
                            this.singleButton("date_range_picker_01", "date_range_picker", "01",),
                            this.singleButton("date_range_picker_03", "date_range_picker", "03",),
                          ],
                        },
                        {
                          id: "time_picker",
                          name: "Time Pickers",
                          icon: "schedule",
                          icon_color: "#009688",
                          options: [
                            this.singleButton("time_picker_01", "time_picker", "01",),
                            this.singleButton("time_picker_03", "time_picker", "03",),
                          ],
                        },
                        {
                          id: "Image_picker",
                          name: "Image Picker",
                          icon: "image",
                          icon_color: "#f252c8ff",
                          options: [
                            this.singleButton("image_picker_1103", "image_picker", "1103",),
                            this.singleButton("image_picker_1203", "image_picker", "1203",),
                            this.singleButton("image_picker_1603", "image_picker", "1603",),
                            this.singleButton("image_picker_1503", "image_picker", "1503",),
                            this.singleButton("image_picker_0103", "image_picker", "0103",),
                            this.singleButton("image_picker_0203", "image_picker", "0203",),
                            this.singleButton("image_picker_0303", "image_picker", "0303",),
                            this.singleButton("image_picker_1703", "image_picker", "1703",),

                            // remove End
                          ],
                       },
                       {
                          id: "video_picker",
                          name: "Video Picker",
                          icon: "videocam",
                          icon_color: "#196f91",
                          options: [
                            this.singleButton("video_picker_0103", "video_picker", "0103",),
                            this.singleButton("video_picker_0203", "video_picker", "0203",),
                            this.singleButton("video_picker_0303", "video_picker", "0303",),
                            // remove End
                          ],
                       },
                       {
                          id: "file_picker",
                          name: "File Picker",
                          icon: "file_open",
                          icon_color: "#52ef7a",
                          options: [
                            this.singleButton("file_picker_0103", "file_picker", "0103",),
                            this.singleButton("file_picker_0203", "file_picker", "0203",),

                          ],
                       },
                       {
                          id: "voice_recorder",
                          name: "Voice Recorder",
                          icon: "graphic_eq",
                          icon_color: "#7152efff",
                          options: [
                            this.singleButton("voice_recorder_0103", "voice_recorder", "0103",),
                            this.singleButton("voice_recorder_0203", "voice_recorder", "0203",),
                          ],
                       },
                       {
                          id: "audio_picker",
                          name: "Audio Picker",
                          icon: "audio_file",
                          icon_color: "#7152efff",
                          options: [
                            this.singleButton("audio_picker_0104", "audio_picker", "0104",),
                          ],
                       },
                       {
                          id: "list_item",
                          name: "List Item",
                          icon: "videocam",
                          icon_color: "#7152efff",
                          options: [
                            this.singleButton("list_item_0103", "list_item", "0103",),
                          ],
                       },
                       {
                          id: "contact_picker",
                          name: "Contact Picker",
                          icon: "contacts",
                          icon_color: "#7152efff",
                          options: [
                            this.singleButton("contact_picker_0103", "contact_picker", "0103",),
                            this.singleButton("contact_picker_0203", "contact_picker", "0203",),
                          ],
                       },
                        {
                          id: "location_picker",
                          name: "Location Picker",
                          icon: "location_on",
                          icon_color: "#FDD835",
                          options: [
                            this.singleButton("location_picker_01", "location_picker", "0103",),
                            this.singleButton("location_picker_03", "location_picker", "0303",),
                            this.singleButton("location_picker_02", "location_picker", "0203",),
                            // remove End
                          ],
                        },
                        {
                          id: "horizontal_list",
                          name: "Horizontal List",
                          icon: "horizontal_distribute",
                          icon_color: "#c582d5",
                          options: [
                            this.singleButton("horizontal_list_1703", "horizontal_list", "1703",),
                            this.singleButton("horizontal_list_1403", "horizontal_list", "1403",),
                            this.singleButton("horizontal_list_2203", "horizontal_list", "2203",),
                            this.singleButton("horizontal_list_1604", "horizontal_list", "1604",),
                            this.singleButton("horizontal_list_1003", "horizontal_list", "1003",),
                            this.singleButton("horizontal_list_0103", "horizontal_list", "0103",),
                            this.singleButton("horizontal_list_0203", "horizontal_list", "0203",),
                          ],
                        },
                             {
                          id: "shipping_picker",
                          name: "Shipping Address",
                          icon: "local_shipping",
                          icon_color: "#e78775",
                          options: [
                            this.singleButton("shipping_picker_01", "shipping_picker", "01",),
                            this.singleButton("shipping_picker_03", "shipping_picker", "03",),
                            this.singleButton("shipping_picker_11", "shipping_picker", "11",),
                            this.singleButton("shipping_picker_13", "shipping_picker", "13",),
                          ],
                        },
                        {
                          id: "delivery_picker",
                          name: "Smart Delivery",
                          icon: "airport_shuttle",
                          icon_color: "#349fff",
                          options: [
                            this.singleButton("delivery_picker_01", "delivery_picker", "01",),
                            this.singleButton("delivery_picker_03", "delivery_picker", "03",),
                            this.singleButton("delivery_picker_11", "delivery_picker", "11",),
                            this.singleButton("delivery_picker_13", "delivery_picker", "13",),
                          ],
                        },
                      ],
                    },
                  ],
                },
              ];
              if (data.show) {
                this.showOffcanvas();
              } else {
                this.hideOffcanvas();
              }
              this.off_canvas_key = data.off_canvas_key;
              break;
            case "signup":
              this.offcanvas_data = [
                {
                  tab: "Basic",
                  data: [
                    {
                      cat: "Components",
                      show: true,
                      name: "Headline",
                      icon: "title",
                      icon_color: "#349fff",
                      item: this.singleButton("bar_01", "bar", "1004"),
                    },
                     {
                      cat: "Filler",
                      show: true,
                      name: "Filler",
                      icon: "square",
                      icon_color: "#fffff",
                      item: this.singleButton("filler_01", "filler", "1004"),
                    },
                    {
                      cat: "Components",
                      show: false,
                      list: [
                        {
                          id: "Text Fields",
                          name: "Text Fields",
                          icon: "text_fields",
                          icon_color: "#ffd96a",
                          options: [
                            this.singleButton("inout_0101", "inout", "01",),
                            this.singleButton("inout_0301", "inout", "03",),
                            this.singleButton("inout_0201", "inout", "02",),
                          ],
                        },

                        {
                          id: "Radio Button",
                          name: "Radio Button",
                          icon: "radio_button_checked",
                          icon_color: "#5671ff",
                          options: [
                            this.singleButton("singlechoice_1000", "singlechoice", "1000",),
                            this.singleButton("singlechoice_2000", "singlechoice", "2000",),
                            this.singleButton("singlechoice_3000", "singlechoice", "3000",),
                          ],
                        },
                        {
                          id: "Checkbox",
                          name: "Checkbox",
                          icon: "check_box",
                          icon_color: "#e78775",
                          options: [
                            this.singleButton("multiplechoice_1000", "multiplechoice", "1000",),
                            this.singleButton("multiplechoice_2000", "multiplechoice", "2000",),
                            this.singleButton("multiplechoice_3000", "multiplechoice", "3000",),
                          ],
                        },
                       {
                          id: "Toggles",
                          name: "Toggles",
                          icon: "toggle_off",
                          icon_color: "#c582d5",
                          options: [
                            this.singleButton("toggle_1000", "toggle", "1000",),
                            this.singleButton("toggle_2000", "toggle", "2000",),
                            this.singleButton("toggle_3000", "toggle", "3000",),
                          ],
                        },
                        {
                          id: "Dropdown",
                          name: "Dropdown",
                          icon: "expand_circle_down",
                          icon_color: "#1abb9c",
                          options: [
                            this.singleButton(this.signupFormMultipleScreen ? "dropdown_signup_01"  :"dropdown_01", "dropdown", "01",),
                            this.singleButton(this.signupFormMultipleScreen?  "dropdown_signup_03"  :"dropdown_03", "dropdown", "03",),
                            this.singleButton(this.signupFormMultipleScreen ? "dropdown_signup_02"  :"dropdown_02", "dropdown", "02",),
                          ],
                        },
                       {
                          id: "SubmitButton",
                          name: "Submit Buttons",
                          //icon: "indeterminate_check_box",
                          icon:"edit_attributes",
                          icon_color: "#22d1ee",

                          options: [
                            this.singleButton("button_0401", "button", "04",),
                            this.singleButton("button_0101", "button", "01",),
                            this.singleButton("button_0301", "button", "03",),
                            this.singleButton("button_0201", "button", "02",),
                            this.singleButton("button_0501", "button", "05",),
                         ],
                        },
                        {
                          id: "slider",
                          name: "Sliders",
                          icon: "display_settings",
                          icon_color: "#FDD835",
                          options: [
                            this.singleButton("single_slider_01", "single_slider", "01",),
                            this.singleButton("single_slider_02", "single_slider", "02",),
                            this.singleButton("single_slider_03", "single_slider", "03",),
                            this.singleButton("range_slider_01", "range_slider", "01",),
                          ],
                        },
                        {
                          id: "date",
                          name: "Date Pickers",
                          icon: "today",
                          icon_color: "#FF9800",
                          options: [
                            this.singleButton("date_picker_01", "date_picker", "01",),
                            this.singleButton("date_picker_03", "date_picker", "02",),
                            this.singleButton("date_range_picker_01", "date_range_picker", "01",),
                            this.singleButton("date_range_picker_03", "date_range_picker", "03",),
                          ],
                        },
                        {
                          id: "time_picker",
                          name: "Time Pickers",
                          icon: "schedule",
                          icon_color: "#009688",
                          options: [
                            this.singleButton("time_picker_01", "time_picker", "01",),
                            this.singleButton("time_picker_03", "time_picker", "03",),
                          ],
                        },
                         {
                          id: "Image_picker",
                          name: "Image Picker",
                          icon: "image",
                          icon_color: "#f252c8ff",
                          options: [
                            // this.singleButton("image_picker_1103", "image_picker", "1103",),
                            this.singleButton("image_picker_1603", "image_picker", "1603",),
                            this.singleButton("image_picker_1503", "image_picker", "1503",),
                            this.singleButton("image_picker_0103", "image_picker", "0103",),
                            this.singleButton("image_picker_0203", "image_picker", "0203",),
                            this.singleButton("image_picker_0303", "image_picker", "0303",),
                            this.singleButton("image_picker_1703", "image_picker", "1703",),

                            // remove End
                          ],
                       },
                       {
                          id: "video_picker",
                          name: "Video Picker",
                          icon: "videocam",
                       icon_color: "#196f91",
                          options: [
                            this.singleButton("video_picker_0103", "video_picker", "0103",),
                            this.singleButton("video_picker_0203", "video_picker", "0203",),
                            this.singleButton("video_picker_0303", "video_picker", "0303",),
                            // remove End
                          ],
                       },
                       {
                          id: "file_picker",
                          name: "File Picker",
                          icon: "file_open",
                          icon_color: "#52ef7a",
                          options: [
                            this.singleButton("file_picker_0103", "file_picker", "0103",),
                            this.singleButton("file_picker_0203", "file_picker", "0203",),

                          ],
                       },
                        {
                          id: "location_picker",
                          name: "Location Picker",
                          icon: "location_on",
                          icon_color: "#FDD835",
                          options: [
                            this.singleButton("location_picker_01", "location_picker", "0103",),
                            this.singleButton("location_picker_03", "location_picker", "0303",),
                            this.singleButton("location_picker_02", "location_picker", "0203",),
                            // remove End
                          ],
                        },

                      ],
                    },
                  ],
                },
              ];
              if (data.show) {
                this.showOffcanvas();
              } else {
                this.hideOffcanvas();
              }
              this.off_canvas_key = data.off_canvas_key;
              break;
            case "store":
              this.offcanvas_data = [
                {
                  tab: "1st TAB",
                  data: [
                    {
                      cat: "Components",
                      show: true,
                      name: "Headline",
                      icon: "title",
                      icon_color: "#349fff",
                      item: this.singleButton("bar_01", "bar", "1004"),
                    },
                     {
                      cat: "Filler",
                      show: true,
                      name: "Filler",
                      icon: "square",
                      icon_color: "#fffff",
                      item: this.singleButton("filler_01", "filler", "1004"),
                    },
                       {id: "Text Area",
                          name: "Text Area",
                          icon: "text_format",
                          icon_color: "#ee695e",
                          options: [
                          this.singleButton("text_01", "text", "1004",),
                          ],
                        },
                     {
                      cat: "CARD",
                      show: false,
                      list: [
                        // this.singleButton("bar_01", "bar", "1004",),
                         {
                          id: "Cards",
                          name: "Cards",
                          icon: "space_dashboard",
                          icon_color: "#52ef7a",
                          options: [
                            this.singleButton("card_06", "card", "0603",),
                            this.singleButton("card_03", "card", "0303",),
                            this.singleButton("card_05", "card", "0503",),
                            this.singleButton("card_04", "card", "0403",),
                            this.singleButton("card_07", "card", "0703",),
                            this.singleButton("card_08", "card", "0803",),
                            // this.singleRow([{ code: "card_0901", form: "card", style: "0903" },  { code: "card_0902", form: "card", style: "0903"  }],"Row", "", collection_composed_images ["card-0901-0902"].image, 60),
                             this.singleRow([{ code: "card_1101", form: "card", style: "1103" },  { code: "card_1102", form: "card", style: "1103"  }],"Row", "", collection_composed_images ["card-1101-1102"].image, 60),
                            this.singleRow([{ code: "card_1301", form: "card", style: "1304" },  { code: "card_1302", form: "card", style: "1304"  }, { code: "card_1303", form: "card", style: "1304"  }],"Row", "", collection_composed_images ["card-1301-1303"].image, 60),
                            this.singleRow([{ code: "card_1401", form: "card", style: "1404" },  { code: "card_1402", form: "card", style: "1404"  }, { code: "card_1403", form: "card", style: "1404"  }],"Row", "", collection_composed_images ["card-1401-1403"].image, 60),
                            this.singleButton("card_21", "card", "2103",),
                           this.singleRow([{ code: "card_2101", form: "card", style: "2103" },  { code: "card_2102", form: "card", style: "2103"  },],"Row", "", collection_composed_images ["card-2101-2102"].image, 60),

                          ],
                        },
                        {
                          id: "Avatar Cards",
                          name: "Avatars",
                          icon: "account_box",
                          icon_color: "#b27df3",
                          options: [
                            // this.singleButton("card_12", "card", "1204",),
                            this.singleButton("card_15", "card", "1504",),
                            this.singleButton("card_16", "card", "1604",),
                            // this.singleButton("card_17", "card", "1704",),
                            this.singleButton("card_20", "card", "2004",),
                          ],

                        },
                         {
                          id: "Carousel",
                          name: "Carousel",
                          icon: "view_carousel",
                          icon_color: "#ee695e",
                          options: [
                            this.singleButton("carousel_02", "carousel", "0200",),
                            this.singleButton("carousel_03", "carousel", "0300",),
                            this.singleButton("carousel_04", "carousel", "0400",),
                            this.singleButton("carousel_01", "carousel", "0100",),
                          ],
                        },
                       {id: "Text Area",
                          name: "Text Area",
                          icon: "text_format",
                          icon_color: "#ee695e",
                          options: [
                          this.singleButton("text_01", "text", "1004",),
                          ],
                        },
                       {
                          id: "Button",
                          name: "Buttons",
                          icon: "indeterminate_check_box",
                          icon_color: "#22d1ee",
                          options: [
                            this.singleButton("button_04", "button", "04",),
                            this.singleButton("button_01", "button", "01",),
                            this.singleButton("button_03", "button", "03",),
                            this.singleButton("button_02", "button", "02",),
                            this.singleButton("button_05", "button", "05",),
                          ],
                        },

                         {
                          id: "Chips",
                          name: "Chips",
                          icon: "check_box",
                          icon_color: "#D0BCFF",
                          options: [
                            this.singleButton("assist_chipset_menu_0102", "assist_chipset", "0102",), //assist outline
                            this.singleButton("single_chipset_menu_0102", "single_chipset", "0102",),  //single Filter outline
                            this.singleButton("multi_chipset_menu_0102", "multi_chipset", "0102",),  //multi Filter outline
                            this.singleButton("single_chipset_menu_0202", "single_chipset", "0202",),  //single Suggestion outline
                            this.singleButton("multi_chipset_menu_0202", "multi_chipset", "0202",), //multi Suggestion outline
                            //this.singleButton("dropdown_chip_menu_02", "dropdown_chip", "0200",),
                          ],
                        },
                            {
                          id: "Search",
                          name: "Search View",
                          icon: "search",
                          icon_color: "#ee695e",
                          options: [
                            this.singleButton("searchview_01", "searchview", "01",)
                          ],
                        },

                        {
                          id: "Collections",
                          name: "Collections",
                          icon: "apps",
                          icon_color: "#ffd96a",
                          options: [
                            // this.singleButton("collection_01", "collection", "0103",),
                            // this.singleButton("collection_02", "collection", "0203",),

                            this.singleRow([
                              { code: "collection_13", form: "collection", style: "0204" },
                              { code: "collection_14", form: "collection", style: "0204" },
                              { code: "collection_15", form: "collection", style: "0204" },
                              { code: "collection_16", form: "collection", style: "0204" }
                            ],
                            "Row", "",
                            collection_composed_images ["collection-13-16"].image, 60),


                            this.singleRow([{ code: "collection_07", form: "collection", style: "0103" },
                              { code: "collection_08", form: "collection", style: "0103"  }], "Row", "",
                            collection_composed_images ["collection-7-8"].image, 60),

                            this.singleRow([{ code: "collection_09", form: "collection", style: "0403" },
                              { code: "collection_10", form: "collection", style: "0403"  }], "Row", "",
                              collection_composed_images ["collection-9-10"].image, 60),

                              this.singleRow([{ code: "collection_11", form: "collection", style: "0503" },
                              { code: "collection_12", form: "collection", style: "0503"  }], "Row", "",
                              collection_composed_images ["collection-11-12"].image, 60),

                            this.singleButton("collection_04", "collection", "0403",),
                            this.singleButton("collection_05", "collection", "0503",),

                         ],
                        },
                                    {
                          id: "shipping_picker",
                          name: "Shipping Address",
                          icon: "local_shipping",
                          icon_color: "#e78775",
                          options: [
                            this.singleButton("shipping_picker_01", "shipping_picker", "01",),
                            this.singleButton("shipping_picker_03", "shipping_picker", "03",),
                            this.singleButton("shipping_picker_11", "shipping_picker", "11",),
                            this.singleButton("shipping_picker_13", "shipping_picker", "13",),
                          ],
                        },
                        {
                          id: "delivery_picker",
                          name: "Smart Delivery",
                          icon: "airport_shuttle",
                          icon_color: "#349fff",
                          options: [
                            this.singleButton("delivery_picker_01", "delivery_picker", "01",),
                            this.singleButton("delivery_picker_03", "delivery_picker", "03",),
                            this.singleButton("delivery_picker_11", "delivery_picker", "11",),
                            this.singleButton("delivery_picker_13", "delivery_picker", "13",),
                          ],
                        },

                      ],
                    },
                  ],
                },
              ];
              if (data.show) {
                this.showOffcanvas();
              } else {
                this.hideOffcanvas();
              }
              this.off_canvas_key = data.off_canvas_key;
              break;
            case "poll":
              this.offcanvas_data = [
                {
                  tab: "Basic",
                  data: [
                    {
                      cat: "Components",
                      show: true,
                      name: "Button",
                      icon: "indeterminate_check_box",
                      icon_color: "#22d1ee",
                      item: this.singleButton("button_02", "button", "02",),
                    },
                  ],
                },
              ];
              if (data.show) {
                this.showOffcanvas();
              } else {
                this.hideOffcanvas();
              }
              this.off_canvas_key = data.off_canvas_key;
              break;
            case "appbar":
              this.offcanvas_data = [
                {
                  tab: "1st TAB",
                  data: [
                     {
                      cat: "CARD",
                      show: false,
                      list: [
                         {
                          id: "buttonIcon",
                          name: "Buttons Icon",
                          icon:"edit_attributes",
                          icon_color: "#22d1ee",
                          options: [
                            this.singleButton("button_icon_0105", "button", "0105",),
                            // this.singleButton("button_icon_0205", "button", "0205",),
                            // this.singleButton("button_icon_0305", "button", "0305",),
                         ],
                        },
                        {
                          id: "context_menu",
                          name: "Context Menu",
                          icon:"menu",
                          icon_color: "#22d1ee",
                          options: [
                            this.singleButton("context_menu_0105", "context_menu", "0105",),
                         ],
                        },
                         {
                          id: "shipping_picker",
                          name: "Shipping Address",
                         icon: "local_shipping",
                          icon_color: "#e78775",
                          options: [
                            this.singleButton("shipping_picker_14", "shipping_picker", "14",),
                          ],
                        },
                        {
                          id: "delivery_picker",
                          name: "Smart Delivery",
                          icon: "airport_shuttle",
                          icon_color: "#349fff",
                          options: [
                            this.singleButton("delivery_picker_14", "delivery_picker", "14",),
                          ],
                        },

                      ],
                    },
                  ],
                },
              ];
              if (data.show) {
                this.showOffcanvas();
              } else {
                this.hideOffcanvas();
              }
              this.off_canvas_key = data.off_canvas_key;
              break;
            case "query":
              this.offcanvas_data = [
                {
                  tab: "Basic",
                  data: [
                    {
                      cat: "Components",
                      show: false,
                      list: [

                        {
                          id: "Search",
                          name: "Search Bar",
                          icon: "search",
                          icon_color: "#ee695e",
                          options: [
                            this.singleButton("searchbar_01", "searchbar", "01",)
                          ],
                        },
                        {
                          id: "Segmented",
                          name: "Segmeneted Buttons",
                          icon: "radio_button_checked",
                          icon_color: "#f5ee66",
                          options: [
                            this.singleButton("singlechoice_segmented_1000", "singlechoice_segmented", "1000",),
                            this.singleButton("multichoice_segmented_1000", "multichoice_segmented", "1000",),
                          ],
                        },

                        {
                          id: "FilterChips",
                          name: "Filter Chips",
                          icon: "check_box",
                          icon_color: "#159647",
                          options: [
                            this.singleButton("single_chipset_0102", "single_chipset", "0102",),  //single Filter outline
                            this.singleButton("multi_chipset_0102", "multi_chipset", "0102",),  //multi Filter outline

                          ],
                        },
                        //  {
                        //   id: "AssistChips",
                        //   name: "Assist Chips",
                        //   icon: "help_center",
                        //   icon_color: "#6583e7",
                        //   options: [
                        //     this.singleButton("assist_chipset_0102", "assist_chipset", "0102",), //assist outline
                        //   ],
                        // },
                        // {
                        //   id: "DropDownChips",
                        //   name: "Dropdown Chips",
                        //   icon: "arrow_drop_down_circle",
                        //   icon_color: "#ee695e",
                        //   options: [
                        //     this.singleButton("dropdown_chip_02", "dropdown_chip", "0102",),
                        //   ],
                        // },
                        {
                          id: "SuggestionChips",
                          name: "Suggestion Chips",
                          icon: "indeterminate_check_box",
                          icon_color: "#1fb306",
                          options: [
                            this.singleButton("single_chipset_0202", "single_chipset", "0202",),  //single Suggestion outline
                            this.singleButton("multi_chipset_0202", "multi_chipset", "0202",), //multi Suggestion outline
                          ],
                        },
                             {
                          id: "Dropdown",
                          name: "Dropdown",
                          icon: "expand_circle_down",
                          icon_color: "#1abb9c",
                          options: [
                            this.singleButton("dropdown_01", "dropdown", "01",),
                            this.singleButton("dropdown_03", "dropdown", "03",),
                            this.singleButton("dropdown_02", "dropdown", "02",),
                          ],
                        },

                      ],
                    },
                  ],
                },
              ];
               if (data.show) {
                  this.showOffcanvas();
                } else {
                  this.hideOffcanvas();
                }
                this.off_canvas_key = data.off_canvas_key;
                break;
            case "market":
                  this.offcanvas_data = [
                    {
                      tab: "1st TAB",
                      data: [
                        {
                          cat: "Components",
                          show: true,
                          name: "Headline",
                          icon: "title",
                          icon_color: "#349fff",
                          item: this.singleButton("bar_01", "bar", "1004"),
                        },
                          {
                          cat: "Filler",
                          show: true,
                          name: "Filler",
                          icon: "square",
                          icon_color: "#fffff",
                          item: this.singleButton("filler_01", "filler", "1004"),
                        },
                        {id: "Text Area",
                          name: "Text Area",
                          icon: "text_format",
                          icon_color: "#ee695e",
                          options: [
                          this.singleButton("text_01", "text", "1004",),
                          ],
                        },

                         {
                      cat: "CARD",
                      show: false,
                      list: [
                        // this.singleButton("bar_01", "bar", "1004",),
                         {
                          id: "Cards",
                          name: "Cards",
                          icon: "space_dashboard",
                          icon_color: "#52ef7a",
                          options: [
                            this.singleButton("card_06", "card", "0603",),
                            this.singleButton("card_03", "card", "0303",),
                            this.singleButton("card_05", "card", "0503",),
                            this.singleButton("card_04", "card", "0403",),
                            this.singleButton("card_07", "card", "0703",),
                            this.singleButton("card_08", "card", "0803",),
                            // this.singleRow([{ code: "card_0901", form: "card", style: "0903" },  { code: "card_0902", form: "card", style: "0903"  }],"Row", "", collection_composed_images ["card-0901-0902"].image, 60),
                            this.singleRow([{ code: "card_1101", form: "card", style: "1103" },  { code: "card_1102", form: "card", style: "1103"  }],"Row", "", collection_composed_images ["card-1101-1102"].image, 60),
                            this.singleRow([{ code: "card_1301", form: "card", style: "1304" },  { code: "card_1302", form: "card", style: "1304"  }, { code: "card_1303", form: "card", style: "1304"  }],"Row", "", collection_composed_images ["card-1301-1303"].image, 60),
                            this.singleRow([{ code: "card_1401", form: "card", style: "1404" },  { code: "card_1402", form: "card", style: "1404"  }, { code: "card_1403", form: "card", style: "1404"  }],"Row", "", collection_composed_images ["card-1401-1403"].image, 60),
                            this.singleButton("card_21", "card", "2103",),
                            this.singleRow([{ code: "card_2101", form: "card", style: "2103" },  { code: "card_2102", form: "card", style: "2103"  },],"Row", "", collection_composed_images ["card-2101-2102"].image, 60),

                          ],
                        },
                        {
                          id: "Avatar Cards",
                          name: "Avatars",
                          icon: "account_box",
                          icon_color: "#b27df3",
                          options: [
                            // this.singleButton("card_12", "card", "1204",),
                            this.singleButton("card_15", "card", "1504",),
                            this.singleButton("card_16", "card", "1604",),
                            // this.singleButton("card_17", "card", "1704",),
                            this.singleButton("card_20", "card", "2004",),
                          ],

                        },
                         {
                          id: "Carousel",
                          name: "Carousel",
                          icon: "view_carousel",
                          icon_color: "#ee695e",
                          options: [
                            this.singleButton("carousel_02", "carousel", "0200",),
                            this.singleButton("carousel_03", "carousel", "0300",),
                            this.singleButton("carousel_04", "carousel", "0400",),
                            this.singleButton("carousel_01", "carousel", "0100",),
                          ],
                        },
                   {id: "Text Area",
                          name: "Text Area",
                          icon: "text_format",
                          icon_color: "#ee695e",
                          options: [
                          this.singleButton("text_01", "text", "1004",),
                          ],
                        },
                       {
                          id: "Button",
                          name: "Buttons",
                          icon: "indeterminate_check_box",
                          icon_color: "#22d1ee",
                          options: [
                            this.singleButton("button_04", "button", "04",),
                            this.singleButton("button_01", "button", "01",),
                            this.singleButton("button_03", "button", "03",),
                            this.singleButton("button_02", "button", "02",),
                            this.singleButton("button_05", "button", "05",),
                          ],
                        },

                         {
                          id: "Chips",
                          name: "Chips",
                          icon: "check_box",
                          icon_color: "#D0BCFF",
                          options: [
                            this.singleButton("assist_chipset_menu_0102", "assist_chipset", "0102",), //assist outline
                            this.singleButton("single_chipset_menu_0102", "single_chipset", "0102",),  //single Filter outline
                            this.singleButton("multi_chipset_menu_0102", "multi_chipset", "0102",),  //multi Filter outline
                            this.singleButton("single_chipset_menu_0202", "single_chipset", "0202",),  //single Suggestion outline
                            this.singleButton("multi_chipset_menu_0202", "multi_chipset", "0202",), //multi Suggestion outline
                            //this.singleButton("dropdown_chip_menu_02", "dropdown_chip", "0200",),
                          ],
                        },
                            {
                          id: "Search",
                          name: "Search View",
                          icon: "search",
                          icon_color: "#ee695e",
                          options: [
                            this.singleButton("searchview_01", "searchview", "01",)
                          ],
                        },
                        {
                          id: "Collections",
                          name: "Collections",
                          icon: "apps",
                          icon_color: "#ffd96a",
                          options: [
                            // this.singleButton("collection_01", "collection", "0103",),
                            // this.singleButton("collection_02", "collection", "0203",),

                            this.singleRow([
                              { code: "collection_13", form: "collection", style: "0204" },
                              { code: "collection_14", form: "collection", style: "0204" },
                              { code: "collection_15", form: "collection", style: "0204" },
                              { code: "collection_16", form: "collection", style: "0204" }
                            ],
                            "Row", "",
                            collection_composed_images ["collection-13-16"].image, 60),


                            this.singleRow([{ code: "collection_07", form: "collection", style: "0103" },
                              { code: "collection_08", form: "collection", style: "0103"  }], "Row", "",
                            collection_composed_images ["collection-7-8"].image, 60),

                            this.singleRow([{ code: "collection_09", form: "collection", style: "0403" },
                              { code: "collection_10", form: "collection", style: "0403"  }], "Row", "",
                              collection_composed_images ["collection-9-10"].image, 60),

                              this.singleRow([{ code: "collection_11", form: "collection", style: "0503" },
                              { code: "collection_12", form: "collection", style: "0503"  }], "Row", "",
                              collection_composed_images ["collection-11-12"].image, 60),

                            this.singleButton("collection_04", "collection", "0403",),
                            this.singleButton("collection_05", "collection", "0503",),

                         ],
                        },
                                    {
                          id: "shipping_picker",
                          name: "Shipping Address",
                          icon: "local_shipping",
                          icon_color: "#e78775",
                          options: [
                            this.singleButton("shipping_picker_01", "shipping_picker", "01",),
                            this.singleButton("shipping_picker_03", "shipping_picker", "03",),
                            this.singleButton("shipping_picker_11", "shipping_picker", "11",),
                            this.singleButton("shipping_picker_13", "shipping_picker", "13",),
                          ],
                        },
                        {
                          id: "delivery_picker",
                          name: "Smart Delivery",
                          icon: "airport_shuttle",
                          icon_color: "#349fff",
                          options: [
                            this.singleButton("delivery_picker_01", "delivery_picker", "01",),
                            this.singleButton("delivery_picker_03", "delivery_picker", "03",),
                            this.singleButton("delivery_picker_11", "delivery_picker", "11",),
                            this.singleButton("delivery_picker_13", "delivery_picker", "13",),
                          ],
                        },

                      ],
                    },
                      ],
                    },
                  ];
                  if (data.show) {
                    this.showOffcanvas();
                  } else {
                    this.hideOffcanvas();
                  }
                  this.off_canvas_key = data.off_canvas_key;
                  break;
            case "custom":
                   this.offcanvas_data = [
                {
                  tab: "Basic",
                  data: [
                    {
                      cat: "Components",
                      show: false,
                      list: [
                       {
                          id: "Text Fields",
                          name: "Text Fields",
                          icon: "text_fields",
                          icon_color: "#ffd96a",
                          options: [
                            this.singleButton("inout_01", "inout", "01",),
                            this.singleButton("inout_03", "inout", "03",),
                            this.singleButton("inout_02", "inout", "02",),
                          ],
                        },

                        {
                          id: "Toggles",
                          name: "Toggles",
                          icon: "toggle_off",
                          icon_color: "#c582d5",
                          options: [
                            this.singleButton("toggle_1000", "toggle", "1000",),
                            this.singleButton("toggle_2000", "toggle", "2000",),
                            this.singleButton("toggle_3000", "toggle", "3000",),
                          ],
                        },
                                     {
                          id: "SubmitButton",
                          name: "Submit Buttons",
                          //icon: "indeterminate_check_box",
                          icon:"edit_attributes",
                          icon_color: "#22d1ee",

                          options: [
                            this.singleButton("button_0402", "button", "04",),
                         ],
                        },
                        {
                          id: "date",
                          name: "Date Pickers",
                          icon: "today",
                          icon_color: "#FF9800",
                          options: [
                            this.singleButton("date_picker_01", "date_picker", "01",),
                            this.singleButton("date_picker_03", "date_picker", "02",),
                            this.singleButton("date_range_picker_01", "date_range_picker", "01",),
                            this.singleButton("date_range_picker_03", "date_range_picker", "03",),
                          ],
                        },

                        {
                          id: "time_picker",
                          name: "Time Pickers",
                          icon: "schedule",
                          icon_color: "#009688",
                          options: [
                            this.singleButton("time_picker_01", "time_picker", "01",),
                            this.singleButton("time_picker_03", "time_picker", "03",),
                          ],
                        },

                        {
                          id: "Image_picker",
                          name: "Image Picker",
                          icon: "space_dashboard",
                          icon_color: "#52ef7a",
                          options: [
                            // this.singleButton("image_picker_1103", "image_picker", "1103",),
                            this.singleButton("image_picker_1603", "image_picker", "1603",),
                            this.singleButton("image_picker_1503", "image_picker", "1503",),
                            this.singleButton("image_picker_0103", "image_picker", "0103",),
                            this.singleButton("image_picker_0203", "image_picker", "0203",),
                            this.singleButton("image_picker_0303", "image_picker", "0303",),
                            this.singleButton("image_picker_1703", "image_picker", "1703",),
                            // remove End
                          ],


                        },
                        {
                          id: "video_picker",
                          name: "Video Picker",
                          icon: "space_dashboard",
                          icon_color: "#196f91",
                          options: [
                            this.singleButton("video_picker_0103", "video_picker", "0103",),
                            this.singleButton("video_picker_0203", "video_picker", "0203",),
                            this.singleButton("video_picker_0303", "video_picker", "0303",),
                            // remove End
                          ],


                        },
                        {
                          id: "Dropdown",
                          name: "Dropdown",
                          icon: "expand_circle_down",
                          icon_color: "#1abb9c",
                          options: [
                            this.singleButton("dropdown_01", "dropdown", "01",),
                            this.singleButton("dropdown_02", "dropdown", "02",),
                          ],
                        },


                      ],
                    },
                  ],
                },
              ];
                  if (data.show) {
                    this.showOffcanvas();
                  } else {
                    this.hideOffcanvas();
                  }
                  this.off_canvas_key = data.off_canvas_key;
                  break;
          }
        }
      }
    );
  }

  drag(event: any, i: any) {
    let data = i;
    switch (this.off_canvas_key) {
      case "home":
      case "side":
        event.dataTransfer.setData("module", data.module);
        break;
      case "page":
      case "menu":
      case "store":
      case "market":
      case "custom":
      case "poll":
      case "appbar":
      case "query":
      case "signup":
      case "custom":
        event.dataTransfer.setData("button", JSON.stringify(data));
        break;
    }
  }


  onClick(event, item) {
    event.stopPropagation();
    event.preventDefault();
    let data = item;
    switch (this.off_canvas_key) {
      case "home":
      case "side":
        this.mdw._offCanvasResponseContainer.next({
          module: this.off_canvas_key,
          item: data.module,
        });


        break;
      case "menu":
      case "page":
      case "store":
      case "market":
      case "custom":
      case "poll":
      case "appbar":
      case "query":
      case "signup":
      case "custom":
        this.mdw._offCanvasResponseContainer.next({
          module: this.off_canvas_key,
          item: JSON.stringify(data),
        });
        break;
    }
  }

  hasItems(item: any) {
    return item.options !== undefined ? item.options.length > 0 : false;
  }

  show(id) {
    const parentElement = document.getElementById(id);
    if (!parentElement.classList.contains("mm-active")) {
      parentElement.classList.add("mm-active");
      parentElement.getElementsByTagName("ul")[0].classList.add("mm-show");
    } else {
      parentElement.classList.remove("mm-active");
      parentElement.getElementsByTagName("ul")[0].classList.remove("mm-show");
    }
  }

  hideOffcanvas() {
    document.querySelector("#offcanvasScrollingMenu").classList.remove("show");
    document.querySelector("#fade").classList.remove("animate-fade-out");
    document.querySelector("#fade").classList.add("animate-fade-in");
  }

  showOffcanvas() {
    document.querySelector("#offcanvasScrollingMenu").classList.add("show");
    document.querySelector("#fade").classList.add("animate-fade-out");
    document.querySelector("#fade").classList.remove("animate-fade-in");
  }

  singleButton(code, form, style, name?, icon?) {
    let component = {
      row: [{ button_code: code, button_form: form, button_style: style, button_style_ios: style, }],
      name: menu_button_map[code].info.name ? menu_button_map[code].info.name : code,
      icon: menu_button_map[code].info.icon, min_grid: menu_button_map[code].info.min_grid,
      image: menu_button_map[code].info.image
    }
    return component
  }

  singleRow(cells, name?, icon?, image?, min_grid?) {
    let row = [];
    cells.forEach(cell => {
      let button = { button_code: cell.code, button_form: cell.form, button_style: cell.style, button_style_ios: cell.style }
      row.push(button)
    });

    let rowData = { row, name: name, icon: icon, image: image, min_grid: min_grid }

    return rowData
  }


  ngOnDestroy(): void {
    if (this.offCanvasSubscription) {
      this.offCanvasSubscription.unsubscribe();
    }

     if (this.customizationSubscription) {
      this.customizationSubscription.unsubscribe();
    }
  }
}


            //  case "page":
            //     this.offcanvas_data = [
            //       {
            //         tab: "Page",
            //         data: [
            //           {
            //             cat: "Basic",
            //             show: false,
            //             list: [
            //               {
            //                 button_code: MENU_BUTTON_CODE.PAGETEXT,
            //                 button_form: "text",
            //                 button_style: "0",
            //                 name: "Page Text",
            //                 icon: "",
            //                 min_grid:
            //                   menu_button_map[MENU_BUTTON_CODE.PAGETEXT]
            //                     .info.min_grid,
            //                 image:
            //                   menu_button_map[MENU_BUTTON_CODE.PAGETEXT]
            //                     .info.image,
            //               },
            //               {
            //                 button_code: MENU_BUTTON_CODE.PAGESLIDER,
            //                 button_form: "pageslider",
            //                 button_style: "1000",
            //                 name: "Image Slider",
            //                 icon: "",
            //                 min_grid:
            //                   menu_button_map[
            //                     MENU_BUTTON_CODE.PAGESLIDER
            //                   ].info.min_grid,
            //                 image:
            //                   menu_button_map[
            //                     MENU_BUTTON_CODE.PAGESLIDER
            //                   ].info.image,
            //               }, {
            //                 button_code: MENU_BUTTON_CODE.PAGESLIDERLABEL,
            //                 button_form: "pagesliderlabel",
            //                 button_style: "2000",
            //                 name: "Image Slider Label",
            //                 icon: "",
            //                 min_grid:
            //                   menu_button_map[
            //                     MENU_BUTTON_CODE.PAGESLIDERLABEL
            //                   ].info.min_grid,
            //                 image:
            //                   menu_button_map[
            //                     MENU_BUTTON_CODE.PAGESLIDERLABEL
            //                   ].info.image,
            //               },

            //               {
            //                 button_code: MENU_BUTTON_CODE.PAGEGALLERY,
            //                 button_form: "pagegallery",
            //                 button_style: "1000",
            //                 name: "Image Gallery",
            //                 icon: "",
            //                 min_grid:
            //                   menu_button_map[
            //                     MENU_BUTTON_CODE.PAGEGALLERY
            //                   ].info.min_grid,
            //                 image:
            //                   menu_button_map[
            //                     MENU_BUTTON_CODE.PAGEGALLERY
            //                   ].info.image,
            //               },
            //               {
            //                 button_code: MENU_BUTTON_CODE.PAGESINGLEIMAGE,
            //                 button_form: MENU_BUTTON_FORM.PAGESINGLEIMAGE,
            //                 button_style: "1000",
            //                 name: "Single Image",
            //                 icon: "",
            //                 min_grid: menu_button_map[MENU_BUTTON_CODE.PAGESINGLEIMAGE].info.min_grid,
            //                 image : menu_button_map[MENU_BUTTON_CODE.PAGESINGLEIMAGE].info.image,
            //               }, {
            //                 button_code: MENU_BUTTON_CODE.PAGEHEADER,
            //                 button_form: MENU_BUTTON_FORM.PAGEHEADER,
            //                 button_style: "1000",
            //                 name: "Header",
            //                 icon: "",
            //                 min_grid: menu_button_map[MENU_BUTTON_CODE.PAGEHEADER].info.min_grid,
            //                 image : menu_button_map[MENU_BUTTON_CODE.PAGEHEADER].info.image,
            //               },{
            //                 button_code: MENU_BUTTON_CODE.PAGEDIVIDER,
            //                 button_form: MENU_BUTTON_FORM.PAGEDIVIDER,
            //                 button_style: "1000",
            //                 name: "Divider",
            //                 icon: "",
            //                 min_grid: menu_button_map[MENU_BUTTON_CODE.PAGEDIVIDER].info.min_grid,
            //                 image : menu_button_map[MENU_BUTTON_CODE.PAGEDIVIDER].info.image,
            //               },
            //               {
            //                 button_code: MENU_BUTTON_CODE.PAGEVIDEO,
            //                 button_form: MENU_BUTTON_FORM.PAGEVIDEO,
            //                 button_style: "1000",
            //                 name: "Video",
            //                 icon: "",
            //                 min_grid: menu_button_map[MENU_BUTTON_CODE.PAGEVIDEO].info.min_grid,
            //                 image : menu_button_map[MENU_BUTTON_CODE.PAGEVIDEO].info.image,
            //               },  {
            //                 button_code: MENU_BUTTON_CODE.PAGEQR,
            //                 button_form: MENU_BUTTON_FORM.PAGEQR,
            //                 button_style: "1000",
            //                 name: "QR",
            //                 icon: "",
            //                 min_grid: menu_button_map[MENU_BUTTON_CODE.PAGEQR].info.min_grid,
            //                 image : menu_button_map[MENU_BUTTON_CODE.PAGEQR].info.image,
            //               },  {
            //                 button_code: MENU_BUTTON_CODE.PAGELOCATION,
            //                 button_form: MENU_BUTTON_FORM.PAGELOCATION,
            //                 button_style: "1000",
            //                 name: "Location",
            //                 icon: "",
            //                 min_grid: menu_button_map[MENU_BUTTON_CODE.PAGELOCATION].info.min_grid,
            //                 image : menu_button_map[MENU_BUTTON_CODE.PAGELOCATION].info.image,
            //               },
            //               {
            //                 button_code: MENU_BUTTON_CODE.PAGEPDFVIEWER,
            //                 button_form: MENU_BUTTON_FORM.PAGEPDFVIEWER,
            //                 button_style: "0",
            //                 name: "Pdf Viewer",
            //                 icon: "",
            //                 min_grid: menu_button_map[MENU_BUTTON_CODE.PAGEPDFVIEWER].info.min_grid,
            //                 image : menu_button_map[MENU_BUTTON_CODE.PAGEPDFVIEWER].info.image,
            //               },{
            //                 button_code: MENU_BUTTON_CODE.PAGESOCIALBAR,
            //                 button_form: MENU_BUTTON_FORM.PAGESOCIALBAR,
            //                 button_style: "1000",
            //                 name: "Social bar",
            //                 icon: "",
            //                 min_grid: menu_button_map[MENU_BUTTON_CODE.PAGESOCIALBAR].info.min_grid,
            //                 image : menu_button_map[MENU_BUTTON_CODE.PAGESOCIALBAR].info.image,
            //               }
            //             ],
            //           },
            //         ],
            //       },
            //     ];
            //     if (data.show) {
            //       this.showOffcanvas();
            //     } else {
            //       this.hideOffcanvas();
            //     }
            //     this.off_canvas_key = data.off_canvas_key;

            //     break;
